import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CookieHelper } from '../../../utils/CookieHelper';
import { StorageHelper } from '../../../utils/StorageHelper';

const ConsultasGestiones: FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <div className="u-display-flex-tablet u-justify-content-space-between">
        <div className="bloque-socio">
          <p className="title__medium u-margin-bottom-small">
            {t('tarjetas.tarjeta-club-mastercard.see-mov')}
          </p>
          <p>
            {t('tarjetas.tarjeta-club-mastercard.go-to')}{' '}
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a
              href="https://areaclientetarjetadecredito.eroski.es/app/index.html#/eroski/login"
              className="link link-demi"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => {
                StorageHelper.deleteUserFromSession();
                CookieHelper.removeUserCookies();
              }}
            >
              {t('tarjetas.tarjeta-club-mastercard.consultas')}
            </a>
          </p>
        </div>
      </div>
    </>
  );
};

export default ConsultasGestiones;
